/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {ADMIN_RESOURCE_PAGES} from '../common/controller/admin-resource-pages';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {ExternalAdUnitModel} from './external-ad-unit-api.service';
import {ExternalAdUnitAnalysisPageComponent} from './external-ad-unit-analysis-page.component';
import {ExternalAdUnitEditPageComponent} from './external-ad-unit-edit-page.component';

@Component({
  standalone: true,
  imports: [...ADMIN_RESOURCE_PAGES, ExternalAdUnitEditPageComponent, ExternalAdUnitAnalysisPageComponent],
  selector: 'adn-external-ad-unit-item-page',
  template: `
    <adn-two-panel-layout>
      <adn-external-ad-unit-edit-page leftPanel [state]="state"></adn-external-ad-unit-edit-page>
      <adn-external-ad-unit-analysis-page rightPanel [state]="state" [model]="state.model()" [isNew]="state.isNew()"></adn-external-ad-unit-analysis-page>
    </adn-two-panel-layout>
  `
})
export class ExternalAdUnitItemPageComponent {
  @Input() state: SignalAdminResourcePageState<ExternalAdUnitModel>;
}
